module.exports = __webpack_public_path__ + "img/software_office.813b406d.jpg";